import { useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { LogoMark, LogoWordmark } from "./Logo";

const LINKS = [
  { label: "Practice Areas", href: "#practice-areas" },
  { label: "Our Attorney", href: "#attorney" },
  { label: "Results", href: "#results" },
  { label: "Offices", href: "#offices" },
];

export const Nav = ({ onBook, onCallback }) => {
  const [open, setOpen] = useState(false);

  return (
    <header data-testid="nav-header" className="fixed top-0 inset-x-0 z-50 border-b border-gold/15 bg-navy-950/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-5 py-3 lg:px-8">
        <a href="#top" className="flex items-center gap-3" aria-label="Heidari Law Group home">
          <LogoMark />
          <LogoWordmark />
        </a>

        <nav className="hidden items-center gap-7 lg:flex">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} className="text-sm font-medium text-slate-300 transition-colors hover:text-gold">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            data-testid="nav-phone-link"
            href="tel:+14172831384"
            className="flex items-center gap-2 font-mono text-sm text-gold transition-colors hover:text-gold-champagne"
          >
            <Phone size={15} /> (417) 283-1384
          </a>
          <button
            data-testid="nav-request-callback-btn"
            onClick={onCallback}
            className="rounded-full border border-gold/40 px-4 py-2 text-sm font-semibold text-gold transition-all hover:border-gold hover:bg-gold/10 active:scale-[0.98]"
          >
            Request Callback
          </button>
          <button
            data-testid="nav-book-consultation-btn"
            onClick={onBook}
            className="btn-sheen rounded-full bg-gradient-to-r from-[#D4AF37] via-[#C5A059] to-[#B38F32] px-5 py-2 text-sm font-bold text-navy-950 shadow-lg shadow-gold/20 transition-all hover:from-[#E6CA65] hover:to-[#D4AF37] active:scale-[0.98]"
          >
            Free Consultation
          </button>
        </div>

        <button data-testid="nav-mobile-menu-btn" className="text-gold lg:hidden" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-gold/15 bg-navy-950/95 px-5 py-6 backdrop-blur-xl lg:hidden">
          <div className="flex flex-col gap-4">
            {LINKS.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-base font-medium text-slate-200 hover:text-gold">
                {l.label}
              </a>
            ))}
            <div className="gold-hairline my-2" />
            <button onClick={() => { setOpen(false); onCallback(); }} className="rounded-full border border-gold/40 px-4 py-3 text-sm font-semibold text-gold">
              Request Callback
            </button>
            <button onClick={() => { setOpen(false); onBook(); }} className="rounded-full bg-gradient-to-r from-[#D4AF37] to-[#B38F32] px-4 py-3 text-sm font-bold text-navy-950">
              Free Consultation
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
